import React from "react";

import chroma from "chroma-js";
import classNames from "classnames";

import { getBlackOrWhiteColorByContrast } from "../../utils/colors";

import type { JSX } from "react";

export const SIZES_TAG = {
  SMALL: "small",
  MEDIUM: "medium",
} as const;

export type SizeTagKeys = keyof typeof SIZES_TAG;

export type SizeTag = (typeof SIZES_TAG)[SizeTagKeys];

interface Props {
  children: React.ReactNode;
  color?: string;
  isFullWidth?: boolean;
  borderColor?: string;
  size?: SizeTag;
  className?: string;
}

export default function Tag({
  children,
  color,
  borderColor,
  isFullWidth = false,
  size = SIZES_TAG.MEDIUM,
  className,
}: Props): JSX.Element {
  const containerClassNames = classNames(
    "text-center rounded-[0.3125rem] border font-semibold truncate",
    { "w-full": isFullWidth },
    { "bg-muted border-border text-foreground": !color },
    {
      "text-[0.703125rem] px-[0.3125rem] py-[0.15625rem] my-[0.15625rem]":
        size === SIZES_TAG.SMALL,
    },
    {
      "text-[0.9375rem] p-[0.46875rem] my-[0.46875rem]":
        size === SIZES_TAG.MEDIUM,
    },
    className,
  );
  return (
    <div
      className={containerClassNames}
      style={
        color
          ? {
              backgroundColor: color,
              borderColor: borderColor ?? chroma(color).darken().hex(),
              color: getBlackOrWhiteColorByContrast(color),
            }
          : undefined
      }
    >
      {children}
    </div>
  );
}
